import moment from "moment/moment";
import { NotificationsLevel } from "../../../lib/enums";
import { show } from "../../../notifications/notifications";
import { useRescan } from "../../samples/hooks";

const useCloudReanalyze = () => {
  const { rescan, sampleStatus, scanData } = useRescan();

  const cloudReanalyze = async (sha1: string, lastSeen: Date | string) => {
    await sampleStatus(sha1);
    const isSubmittedForReanalyze = moment
      .utc(scanData.current.submittedForRescan)
      .isAfter(moment.utc(lastSeen));
    if (isSubmittedForReanalyze) {
      show({
        level: NotificationsLevel.INFO,
        message: "Sample is already submitted for analysis."
      });
    } else {
      rescan(sha1);
    }
  };

  return { cloudReanalyze };
};

export default useCloudReanalyze;
